
export type GetUserById404 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
